import { render } from "./CourseDetails2.vue?vue&type=template&id=69440fbc&scoped=true"
import script from "./CourseDetails2.vue?vue&type=script&lang=js"
export * from "./CourseDetails2.vue?vue&type=script&lang=js"

import "./CourseDetails2.vue?vue&type=style&index=0&id=69440fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69440fbc"]])

export default __exports__